import { FC, useEffect, useState } from 'react';
import { Box, Grid, styled, Typography } from '@mui/material';

import { useAppSelector } from 'state/hooks';
import { Link } from 'react-scroll';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

// main section
const MainSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
//   minHeight: '300px',
  alignItems: 'center',
  border: '1px solid rgba(255,255,255,0.5)', 
  justifyContent: 'center',
  borderRadius: '5px',
  height: '100%',
  maxHeight: '205px',
  width: '100%',
  boxShadow:
  '0px 100px 77px rgba(0, 0, 0, 0.13), 0px 25.9935px 52.3711px rgba(0, 0, 0, 0.0989853), 0px 10.1608px 47.2956px rgba(0, 0, 0, 0.0902431), 0px 5.70356px 44.4605px rgba(0, 0, 0, 0.0829201), 0px 3.80638px 39.8596px rgba(0, 0, 0, 0.0717558), 0px 2.15748px 29.2214px rgba(0, 0, 0, 0.0505145)',
 // 5A687D
  overflow: 'clip',
  transform: 'translate3d(0px, 0px, 0px)',
  "&:hover": {
    boxShadow:
    '0px 100px 77px rgba(0, 0, 0, 0.2), 0px 25.9935px 52.3711px rgba(0, 0, 0, 0.189853), 0px 10.1608px 47.2956px rgba(0, 0, 0, 0.1902431), 0px 5.70356px 44.4605px rgba(0, 0, 0, 0.1829201), 0px 3.80638px 39.8596px rgba(0, 0, 0, 0.0717558), 0px 2.15748px 29.2214px rgba(0, 0, 0, 0.0505145)',
    transform: 'translate3d(0px, -4px, 0px)',
    border: '1px solid rgba(255,255,255,0.8)', 
   // 5A687D
  },
  transition: 'all 0.25s ease-in-out',
}));

const MenuImg = styled('img')(({theme}) => ({
    width: '100%',
    height: '100%',
    maxWidth: '200px',
    position: 'absolute',
    minHeight: "100px",
    objectFit: 'cover',
    filter: 'blur(2px)',
    [theme.breakpoints.up('xs')]: {
        maxHeight: '180px',
        maxWidth: '500px',
      },
      [theme.breakpoints.up('sm')]: {
        maxHeight: '200px',
        maxWidth: '350px',
      },
      [theme.breakpoints.up('md')]: {
        maxHeight: '100%',
        maxWidth: '200px',
      },
  }));
  
const Title = styled(Typography)(({ theme }) => ({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  padding: '20px',
  fontWeight: '600',
  color: theme.palette.text.primary,
  textShadow: "-1px 1px 10px rgba(0, 0, 0, 0.75)",
  fontSize: '20px',
  transition: 'all 0.5s ease-in-out',
  // lineHeight: '20px',
  maxWidth: '500px',
  lineWidth: '500px',
  textWrap: 'wrap',
  textAlign: 'center',
  zIndex: '1',
  whiteSpace: "pre-line",
  // textWrap: 'wrap',
  wordBreak: 'break-word',
  // overflow: 'break-word',
  nowrap: false,
  // textOverflow: "ellipsis",
  // overflowWrap: 'break-word',
  // wordBreak: "break-word",
  [theme.breakpoints.up('xs')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.up('sm')]: {
  },
}));

interface Props {
    data: any
}

const PhotoCard: React.FC<Props> = ({ data }) => {

  const [isMouseOnTarget, setIsMouseOnTarget] = useState<boolean>(false);
  const onMouseEnter = async () => {
    setIsMouseOnTarget(true)
  };

  const onMouseLeave = async () => {
    setIsMouseOnTarget(false)
  };

  return (
        <>
        <MainSection>
            <img alt="" src={data?.original}/>
        </MainSection>
        </>
  );
};

export default PhotoCard;
